// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { APP_ENV } from "src/app/shared/conf/app_env";

export const environment = {
	production: false,
	apiUrl: '/api/',
	// apiUrl: 'http://localhost:3000/',
	// localhost
	mainColor: 'blue',
	appEnv: APP_ENV.Latam,
  	staticMap: "https://maps.googleapis.com/maps/api/staticmap",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
